import type { Components, Theme } from "@mui/material/styles";

const VALUT_INPUT_BORDER = "rgba(211, 169, 113, 0.55)";
const VALUT_INPUT_BORDER_HOVER = "#d3a971";
const VALUT_INPUT_BORDER_FOCUS = "#e7a73f";
const VALUT_INPUT_FOCUS_RING = "rgba(231, 167, 63, 0.2)";
const VALUT_INPUT_RADIUS = 8;

export const valutMuiComponents: Components<Theme> = {
  MuiTextField: {
    defaultProps: {
      variant: "outlined",
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: VALUT_INPUT_RADIUS,
        backgroundColor: "#fff",
        fontSize: "0.875rem",
        transition: "box-shadow 0.2s ease",
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: VALUT_INPUT_BORDER_HOVER,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: VALUT_INPUT_BORDER_FOCUS,
          borderWidth: "1px",
        },
        "&.Mui-focused": {
          boxShadow: `0 0 0 2px ${VALUT_INPUT_FOCUS_RING}`,
        },
        "&.Mui-disabled": {
          backgroundColor: "#f9fafb",
        },
      },
      notchedOutline: {
        borderColor: VALUT_INPUT_BORDER,
        borderRadius: VALUT_INPUT_RADIUS,
      },
      input: {
        color: "#1a1a1a",
        "&::placeholder": {
          color: "#a3a3a3",
          opacity: 1,
        },
      },
      inputSizeSmall: {
        fontSize: "0.875rem",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontSize: "0.875rem",
        fontWeight: 500,
        color: "#4b5563",
        "&.Mui-focused": {
          color: "#9a7340",
        },
      },
      sizeSmall: {
        fontSize: "0.875rem",
      },
    },
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        borderRadius: VALUT_INPUT_RADIUS,
        backgroundColor: "#fff",
        border: `1px solid ${VALUT_INPUT_BORDER}`,
        overflow: "hidden",
        "&:before, &:after": {
          display: "none",
        },
        "&:hover": {
          backgroundColor: "#fff",
          borderColor: VALUT_INPUT_BORDER_HOVER,
        },
        "&.Mui-focused": {
          backgroundColor: "#fff",
          borderColor: VALUT_INPUT_BORDER_FOCUS,
          boxShadow: `0 0 0 2px ${VALUT_INPUT_FOCUS_RING}`,
        },
      },
      input: {
        color: "#1a1a1a",
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontSize: "0.75rem",
        color: "#6b7280",
        marginLeft: 0,
      },
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: {
        fontSize: "0.875rem",
        color: "#1a1a1a",
      },
      icon: {
        color: "#6b7280",
      },
    },
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: "#6b7280",
      },
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      inputRoot: {
        borderRadius: VALUT_INPUT_RADIUS,
        backgroundColor: "#fff",
      },
    },
  },
};
